import { toast } from 'react-toastify';
import {
  FETCH_ROOM_DATA_BEGIN,
  FETCH_ROOM_DATA_SUCCESS,
  FETCH_ROOM_DATA_ERROR
} from './fetchRoomData';
import { UPDATE_ROOM_BEGIN, UPDATE_ROOM_ERROR, UPDATE_ROOM_SUCCESS } from 'modules/User/redux/updateRoom';

const initialState = {
  data: null,
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
      case FETCH_ROOM_DATA_BEGIN:
      case UPDATE_ROOM_BEGIN:
      return {
          ...state,
          isLoading: true,
          error: null
      };

      case FETCH_ROOM_DATA_SUCCESS:
      if (action.payload.data.code) {
        toast.error(action.payload.data.message);
      }
      return {
          ...state,
          error: null,
          isLoading: false,
          data: action.payload.data
      };

      case UPDATE_ROOM_SUCCESS:
      if (action.payload.data.code) {
        if (action.payload.data.code !== '010') {
            toast.error(action.payload.data.message);
        }
      }
      return {
          ...state,
          error: null,
          isLoading: false,
          data: null
      }

      case FETCH_ROOM_DATA_ERROR:
      case UPDATE_ROOM_ERROR:
      if (action.payload.error) {
        toast.error(action.payload.error);
      }
      return {
          ...state,
          isLoading: false,
          error: action.payload.error,
      };

      default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/User/redux/roomReducer.js